<template>
  <div>
    <div
      v-if="
        $route.path.indexOf('_detail') === -1 &&
        $route.path.indexOf('_edit') === -1
      "
    >
      <el-row :gutter="24">
        <el-col :span="3">
          <el-input
            placeholder="店铺编号"
            v-model="params.sub_unit_num_id"
            style="width: 100%"
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="searchData" size="mini"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column
          prop="sub_unit_num_id"
          label="店铺编号"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="证照名称"
        ></el-table-column>
        <el-table-column
        prop="license_no"
        label="证照编号"
      ></el-table-column>
        <el-table-column
          prop="begin_date"
          label="证照开始日期"
        >
        <template slot-scope="scope">
          <span>{{scope.row.begin_date | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
      </template>
      </el-table-column>
        <el-table-column
          prop="end_date"
          label="证照结束日期"
        >
        <template slot-scope="scope">
          <span>{{scope.row.end_date | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
      </template>
      </el-table-column>
      <el-table-column
          prop="last_updtme"
          label="更新日期"
        >
        <template slot-scope="scope">
          <span>{{scope.row.last_updtme | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
      </template>
      </el-table-column>
      <el-table-column
          label="预览"
        >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEditDistribution(scope.row)">预览资质</el-button>
      </template>
      </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tag size="" type="danger" effect="plain" @click="edit(scope.row,scope.$index,1)"
              >一键更新</el-tag
            > 
            <el-tag size="" type="primary" effect="plain" @click="edit(scope.row,scope.$index,2)"
            >忽略</el-tag
          >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="资质对比" :visible.sync="distributor_dialog" :close-on-click-modal="false">
        <el-form v-model="distributor_form" label-width="auto">  
          <el-row>  
            <el-col :span="12"> <!-- 占据12个栅格，即一半宽度 -->  
              <el-form-item label="资质名称（旧）">  
                <el-input :disabled="true" v-model="distributor_form.old_ad_desc"></el-input>  
              </el-form-item>  
              <el-form-item label="资质图片（旧）">  
                <template slot-scope="scope">
                  <el-popover
                      placement="top"
                      width="260"
                      trigger="click"
                      v-model="visible">
                      <img :src="newimageurl" :style="imageStyle" @click="rotateImage1" >
                      <el-button type="text" slot="reference">
                          <img :src="wximageurl + distributor_form.old_image" style="width:95%;height:95%;"  @click="showtitle(wximageurl +distributor_form.old_image)" >
                      </el-button>
                  </el-popover>
                </template>
                <!-- <img :src="wximageurl + distributor_form.old_image" style="width:300px;"/>   -->
              </el-form-item>  
            </el-col>  
            <el-col :span="12"> <!-- 同样占据12个栅格，即另一半宽度 -->  
              <el-form-item label="资质名称（新）">  
                <el-input :disabled="true" v-model="distributor_form.new_ad_desc"></el-input>  
              </el-form-item>  
              <el-form-item label="资质图片（新）">  
                <template slot-scope="scope">
                  <el-popover
                      placement="top"
                      width="260"
                      trigger="click"
                      v-model="visible">
                      <img :src="newimageurl1" :style="imageStyle" @click="rotateImage">
                      <el-button type="text" slot="reference">
                          <img :src="wximageurl + distributor_form.new_image" style="width:95%;height:95%;"  @click="showtitle1(wximageurl +distributor_form.new_image)" >
                      </el-button>
                  </el-popover>
                </template>
                <!-- <img :src="wximageurl + distributor_form.new_image" style="width:300px;"/>   -->
              </el-form-item>  
            </el-col>  
          </el-row>  
        </el-form>
      </el-dialog>
      <div class="content-center content-top-padded">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="params.page"
          :page-sizes="[10, 20, 50]"
          :total="total_count"
          :page-size="params.pagesize"
        >
        </el-pagination>
      </div>
      <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import imgPicker from "@/components/imageselect";
import draggable from "vuedraggable";
import {getQualificationBasic,editDian,getQualificationBasicDetail} from "../../api/qualification";
export default {
   components: { imgPicker, draggable },
  data() {
    return {
      rotateDeg: 0,
      pickerImgType: "",
      newimageurl:'',
      newimageurl1:'',
      imgDialog: false,
      distributor_dialog:false,
      isGetImage: false,
      dialogFormVisible: false,
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
        status:2
      },
      form: {
        item_num_id: "",
        item_name: "",
        approval_no: "",
        approval_url: "",
        approval_begin_date:"",
        approval_end_date:""
      },
      distributor_form:{
          new_image:'',
          new_ad_desc:'',
          old_image:'',
          old_ad_desc:''
      },
      dataList: [],
      loading: false,
      id: "",
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
    imageStyle() {  
      return {  
        transform: `rotate(${this.rotateDeg}deg)`,  
        // 注意：你可能需要调整 width 和 height，或者完全移除它们，取决于你的布局需求  
        width: '250%', // 通常不建议在 img 标签上直接设置百分比宽度，除非你有特定的布局需求  
        height: '250%', // 同上  
      };  
    },  
  },
  methods: {
    edit(row,index,flag) {
      console.log(row,index);
      row['flag'] = flag;
      var that = this;
      this.$confirm("确定已提醒三方平台更换资质并更新店铺资质？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            editDian(row,flag).then((res) => {
              if (res.status) {
                this.$message({
                  message: "已更新",
                  type: "success",
                  duration: 2000,
                });
                setTimeout(function () {
                  that.dataList.splice(index, 1);
                }, 1000);
              }
            });
          }
          done();
        },
      });
    },
    rotateImage() {  
      this.rotateDeg = (this.rotateDeg + 90) % 360; // 每次旋转90度  
    },
    rotateImage1() {  
      this.rotateDeg = (this.rotateDeg + 90) % 360; // 每次旋转90度  
    },
    showtitle(row){
      this.newimageurl = row
    },
    showtitle1(row){
      this.newimageurl1 = row
    },
    handleEditDistribution(row)
      {
        getQualificationBasicDetail(row)
        .then((response) => {
          this.distributor_dialog = true
          this.distributor_form.old_ad_desc = response.data.data.old_ad_desc
          this.distributor_form.old_image = response.data.data.old_image
          this.distributor_form.new_ad_desc = response.data.data.new_ad_desc
          this.distributor_form.new_image = response.data.data.new_image
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
      },
    getDataList() {
      this.loading = true;
      getQualificationBasic(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
     pickImg(data) {
      this.form[this.pickerImgType] = data.url;
      this.imgDialog = false;
    },
    handleImgPicker(pickerImgType) {
      this.pickerImgType = pickerImgType;
      this.imgDialog = true;
      this.isGetImage = true;
    },
    closeImgDialog() {
      this.imgDialog = false;
      this.isGetImage = false;
    },
  },
  mounted() {
    this.getDataList();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
.service-label .el-checkbox:first-child {
  margin-left: 15px;
}
.service-label .el-input:first-child {
  margin-left: 15px;
}
.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.el-carousel {
  width: 375px;
}
.grid-detail {
  table,
  .detail-content-wrap,
  .detail-content-item {
    width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// updatedian.vue?0257bcb6